
$(document).ready(function () {

	// wait untill all images inside our masonary layout are loaded
	var $masonary = $('.js-masonary').imagesLoaded().progress(function () {

		// initialize isotope
		$masonary.isotope({
			itemSelector: '.js-masonary__item',
			percentPosition: true,
			masonry: {
				// columnWidth: 33.333333%
			}
		});

		// store filter for each group
		var filters = {};

		$('.filter').on('click', 'button', function (event) {
			var $button = $(event.currentTarget);

			// get group key
			var $buttonGroup = $button.parents('.js-filter__group');
			var filterGroup = $buttonGroup.attr('data-filter-group');

			// set filter for group
			filters[filterGroup] = $button.attr('data-filter');

			// combine filters
			var filterValue = concatValues(filters);

			// set filter for Isotope
			$masonary.isotope({
				filter: filterValue
			});
		});

		// change is-checked class on buttons
		$('.js-filter__group').each(function (i, buttonGroup) {

			var $buttonGroup = $(buttonGroup);

			$buttonGroup.on('click', 'button', function (event) {
				$buttonGroup.find('.filter__btn--is-current').removeClass('filter__btn--is-current');
				var $button = $(event.currentTarget);
				$button.addClass('filter__btn--is-current');

				// quick and dirty remove our offset classes
				$('.js-masonary__item').removeClass('teaser--offset-sm teaser--offset-md teaser--offset-lg');
			});
		});

		// flatten object by concatting values
		function concatValues(obj) {
			var value = '';
			for (var prop in obj) {
				value += obj[prop];
			}
			return value;
		}

	})

});
